
const ci = {
    testing: process.env.JEST_WORKER_ID || process.env.NODE_ENV === 'test'
};

export default ci;
